import { render } from "./icon-avatar.vue?vue&type=template&id=66519b52"
import script from "./icon-avatar.vue?vue&type=script&lang=js"
export * from "./icon-avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__